export var BRPhoneMask = ["(", "/\\d/", "/\\d/", ")", " ", "/\\d/", "/\\d/", "/\\d/", "/\\d/", "/\\d/", "-", "/\\d/", "/\\d/", "/\\d/", "/\\d/"];
export var BRPhoneResidentialMask = ["(", "/\\d/", "/\\d/", ")", " ", "/\\d/", "/\\d/", "/\\d/", "/\\d/", "-", "/\\d/", "/\\d/", "/\\d/", "/\\d/"];
export function BRPhoneHybridMask(value) {
  var safeValue = value || "";
  var onlyNums = safeValue.replace(/\D/g, "");
  var filledResidencial = onlyNums.length >= 11;
  return filledResidencial ? BRPhoneMask : BRPhoneResidentialMask;
}